import React, { useContext } from 'react';
import { VolumeCapsuleData } from 'widgets/liquiditySummary/volumeCapsule/components/volumeCapsuleData';
import './VolumeCapsuleValues.scss';
import AppContext from 'app/AppContext';
import * as tooltips from './help/volumeCapsuleChartValuesTooltips';
import Tooltip from 'utils/components/Tooltip/Tooltip';

export interface VolumeCapsuleValuesProps {
    chartData: VolumeCapsuleData;
}

export function VolumeCapsuleValues(props: VolumeCapsuleValuesProps) {
    const { chartData } = props;
    const { numberFormat } = useContext(AppContext);

    return (
        <div className="VolumeCapsuleValues capsule-values flippable">
            <div>
                <div className="label">
                    <Tooltip text={tooltips.hNow}>H Now</Tooltip>
                </div>
                <div className="value">
                    {numberFormat.n0(
                        chartData.historical.open + chartData.historical.volume
                    )}
                </div>
                <div className="label">
                    <Tooltip text={tooltips.tNow}>T Now</Tooltip>
                </div>
                <div className="value">
                    {numberFormat.n0(
                        chartData.today.open + chartData.today.volume
                    )}
                </div>
            </div>
            <div>
                <div className="label">
                    {' '}
                    <Tooltip text={tooltips.hDay}>H Day</Tooltip>
                </div>
                <div className="value">
                    {numberFormat.n0(chartData.historicalTotal)}
                </div>
                <div className="label">
                    <Tooltip text={tooltips.tDay}>T Day</Tooltip>
                </div>
                <div className="value">
                    {numberFormat.n0(chartData.todayTotal)}
                </div>
            </div>
            <div>
                <div className="label">
                    <Tooltip text={tooltips.hOpen}>H Open</Tooltip>
                </div>
                <div className="value">
                    {numberFormat.n0(chartData.historical.open)}
                </div>
                <div className="label">
                    <Tooltip text={tooltips.hClose}>H Close</Tooltip>
                </div>
                <div className="value">
                    {numberFormat.n0(chartData.historical.close)}
                </div>
            </div>
            <div>
                <div className="label">
                    <Tooltip text={tooltips.tRem}>T Rem</Tooltip>
                </div>
                <div className="value">
                    {numberFormat.n0(
                        chartData.today.remainingVolume + chartData.today.close
                    )}
                </div>
                <div className="label">
                    <Tooltip text={tooltips.tClose}>T Close</Tooltip>
                </div>
                <div className="value">
                    {numberFormat.n0(chartData.today.close)}
                </div>
            </div>
            <div>
                <div className="label">
                    <Tooltip text={tooltips.tAdj}>T Adj</Tooltip>
                </div>
                <div className="value">
                    {numberFormat.n0(chartData.todayAdjPercent)}%
                </div>
            </div>
        </div>
    );
}
